import { createSelector } from 'reselect';
import { property, identity } from 'lodash';

export const getArticle = createSelector(property('article'), identity);
export const isLoaded = createSelector(getArticle, property('isLoaded'));
export const getError = createSelector(getArticle, property('error'));



// WEBPACK FOOTER //
// ./src/modules/ArticleDetail/selectors/index.js